import { Box, Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

export const CustomCircularProgress = styled(CircularProgress)({
  color: '#1E5A61',
});

export const LoadingWrapper = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  height: '50vh',
  justifyContent: 'center',
  width: '100%',
});

export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 103px)',
  justifyContent: 'space-between',
  padding: '0px',
});

export const OutlinedButton = styled(Button)({
  '& .MuiButtonBase-root': {
    borderRadius: '8px',
  },
  '&:hover': {
    borderColor: '#1E4A61',
    color: '#1E4A61',
  },
  alignItems: 'center',
  border: '1px solid #AC4A4A',
  borderRadius: '8px',
  color: '#AC4A4A',
  display: 'flex',
  fontSize: 16,
  fontWeight: 700,
  gap: '8px',
  height: '56px',
  padding: '0 24px',
  textTransform: 'unset',
  textWrap: 'nowrap',
});

export const ContainedButton = styled(Button)({
  '& .MuiButtonBase-root': {
    borderRadius: '8px',
  },
  '&:hover': {
    background: '#1E4A61',
    borderColor: '#1E4A61',
  },
  background: '#AC4A4A',
  border: '1px solid #AC4A4A',
  borderRadius: '8px',
  color: '#FFF',
  display: 'flex',
  fontSize: 16,
  fontWeight: 700,
  gap: '8px',
  height: '56px',
  padding: '0 24px',
  textTransform: 'unset',
});

export const MainContainer = styled(Box)({
  height: '100vh',
  width: '100%',
});
